<template>
  <v-item-group
    v-model="selectedModel"
    class="d-flex"
    multiple
    mandatory
  >
    <v-item
      v-for="filter in filters"
      :key="filter"
      v-slot="{ active, toggle }"
      :value="filter"
      class="mr-2"
    >
      <duplicates-filter
        :filter-by="filter"
        :review="review"
        :selected="active"
        @click="toggle"
      />
    </v-item>
  </v-item-group>
</template>

<script>
import DuplicatesFilter from './DuplicatesFilter';
import { Review } from '@/models';
import { DuplicateFilterBy } from '@/enums';
import { typeHelpers } from '@/modules';

export default {
  name: 'DuplicatesFilters',
  components: { DuplicatesFilter },
  props: {
    review: {
      type: Review,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
      validator: (val) =>
        typeHelpers.isArrayOfEnum(val, DuplicateFilterBy),
    },
  },
  emits: ['update:selected'],
  computed: {
    selectedModel: {
      get: function () {
        return this.selected;
      },
      set: function (value) {
        this.$emit('update:selected', value);
      },
    },
    filters() {
      return Object.values(DuplicateFilterBy);
    },
  },
};
</script>
